module.exports = __webpack_public_path__ + "img/5.c0c5f057.png";